import React, { useEffect, useState } from 'react'
import Confetti from 'react-confetti'
import Question from '../components/Questions/Question'
import {
  useGetParentScreenQuestions,
  useGetCurrentWeek,
  useParentScreenerData,
} from '../hooks/dataSource'
import { AgeButton, MainContainer } from '../theme'
import useWindowSize from 'react-use/lib/useWindowSize'
import { useSubmitScreener, useSetTimeData } from '../hooks/dataSource'
import DialogBox from '../components/DialogBox'
import { HOME_VIEW } from '../resources/appRoutes'
import { Image } from 'react-bootstrap'
import {
  PARENTSCREENER_POPUP,
  PARENTSCREENER_SUCCESS_POPUP,
} from '../resources/labels.json'

const { TITLE, MESSAGE } = PARENTSCREENER_POPUP

const {
  TITLE: SUCCESSTITLE,
  MESSAGE: SUCCESSMESSAGE,
} = PARENTSCREENER_SUCCESS_POPUP

let parentDelta = 0

function ParentScreener(props) {
  const [
    postScreener,
    { loading: loadingSubmit, error: errorSubmit, data: dataSubmit },
  ] = useSubmitScreener()
  const [questions, setQuestions] = useState([])
  const [visible, setVisible] = useState(false)
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null)
  const [lastQuestionIndex, setLastQuestionIndex] = useState(null)
  const userId = localStorage.getItem('id')
  const { data: currentWeek } = useGetCurrentWeek(userId)

  const [
    submitParentData,
    { loading: psLoader, error: psError, data: psData },
  ] = useParentScreenerData()

  const { loading, error, data, refetch } = useGetParentScreenQuestions(userId)
  const { width, height } = useWindowSize()
  const [title, setTitle] = useState('')
  const [showConfetti, setShowConfetti] = useState(false)
  const [message, setMessage] = useState('')
  const [setNewTime, { error: errorTime }] = useSetTimeData()

  const [screenerId, setScreenerId] = useState('')

  const getMonth = (week) => {
    return parseInt(week / 4) + 1
  }

  useEffect(() => {
    if (data) {
      let  week  = currentWeek?.currentWeek?.week
      const month = getMonth(week)
      if (data?.parentScreener.length < 1) {
        // props.history.push(HOME_VIEW)
        window.sendEvent({
          type: 'PS_NOT_AVAILABLE',
          data:{
            Userweek: week,
            Month: month,
            UserID: userId,
          }
        })
        setTitle(TITLE)
        setMessage(MESSAGE)
        setVisible(true)
      } else {
        setQuestions(data.parentScreener)
        setActiveQuestionIndex(0)
        setLastQuestionIndex(data.parentScreener.length - 1)
      }
    }
    // if (data) {
    //   console.log('data2')
    //   setQuestions(data.parentScreener)
    //   setActiveQuestionIndex(0)
    //   setLastQuestionIndex(data.parentScreener.length - 1)
    // } else {
    //   if(data?.parentScreener.length<1){
    //     props.history.push(HOME_VIEW)
    //   }
    //   console.log('data1',data?.parentScreener)
    // }
  }, [data, currentWeek])

  useEffect(() => {
    if (dataSubmit) {
      const { week } = currentWeek.currentWeek
      const month = getMonth(week)
      window.sendEvent({
        type: 'PS_PERSONA_RESULT',
        data: {
          Userweek: week,
          Month: month,
          UserID: userId,
          userPersonal: dataSubmit?.screen?.message,
        },
      })

      setVisible(true)
      setTitle(SUCCESSTITLE)
      setMessage(dataSubmit?.screen?.message)
      setShowConfetti(true)
      submitParentData(userId, screenerId, 'completed')
    }
  }, [dataSubmit])

  const getSelectedOption = (questions, activeQuestionIndex, index) => {
    const currentQuestion = questions.filter(
      (question, index) => index === activeQuestionIndex
    )

    let answer
    if (currentQuestion && currentQuestion.length > 0) {
      const optionsArray = currentQuestion[0].option
      answer = optionsArray[index]
    }

    return answer
  }

  const setAnswerHandler = (index, id, screenerId) => {
    // submitParentData(userId, screenerId, 'attempted')
    const selectedOption = getSelectedOption(
      questions,
      activeQuestionIndex,
      index
    )
    const { week } = currentWeek.currentWeek
    const month = getMonth(week)
     window.sendEvent({
       type: 'PS_QUESTION_ATTEMPT',
       data: {
         Userweek: week,
         Month: month,
         UserID: userId,
        optionSelected: selectedOption
       },
     })

    const markAnswers = questions.map((question) =>
      question._id === id ? { ...question, answer: index } : question
    )
    setScreenerId(screenerId)
    setQuestions(markAnswers)
  }

  const handleTime = () => {
    let startParentScreener = localStorage.getItem('startParentScreener')
    let submitParentScreener = new Date().getTime()
    parentDelta += parseFloat(
      (submitParentScreener - startParentScreener) * 0.001
    )
    localStorage.setItem('ParentDelta', parentDelta)
    localStorage.setItem('startParentScreener', new Date().getTime())
  }

  const submitAnswers = () => {
    // setTitle(SUCCESSTITLE)
    // console.log('dataSubmit', dataSubmit)
    // setMessage(SUCCESSMESSAGE)
    // setVisible(true)
    handleTime()
    const { week } = currentWeek.currentWeek
    const month = getMonth(week)

    window.sendEvent({
      type: 'PS_COMPLETE',
      data: {
        Userweek: week,
        Month: month,
        UserID: userId,
      },
    })

    let sendData = {
      id: userId,
      result: null,
      answer: [],
    }
    if (questions.length) {
      sendData = {
        ...sendData,
        result: 'max' + getResult().toUpperCase(),
        answer: getAnswer(),
      }

      postScreener(sendData.id, sendData.result, sendData.answer)
    }
  }

  const getAnswer = () => {
    return questions.map((question) => ({
      questionId: question._id,
      answer: getChar(question.answer),
    }))
  }

  const getResult = () => {
    let charMap = {}
    let charMapArr = []
    questions.forEach((question) => {
      charMapArr.push(question.answer)
      if (charMap[getChar(question.answer)]) {
        charMap[getChar(question.answer)]++
      } else {
        charMap[getChar(question.answer)] = 1
      }
    })

    let maxChar = ''
    let maxNum = 0
    let maxArr = []
    for (const index in charMap) {
      const count = charMap[index]
      const char = index

      if (count > maxNum) {
        maxNum = count
        maxChar = char
        maxArr = []
        maxArr.push(char)
      }
      if (count === maxNum && !maxArr.includes(char)) {
        maxArr.push(char)
      }
    }
    let sortedArr = maxArr.sort()

    return sortedArr[sortedArr.length - 1]
  }

  const getChar = (index) => {
    switch (parseInt(index)) {
      case 0:
        return 'a'
      case 1:
        return 'b'
      case 2:
        return 'c'
      case 3:
        return 'd'
      default:
        break
    }
  }

  const moveQuestion = () => {
    handleTime()
    setActiveQuestionIndex(activeQuestionIndex + 1)
  }

  const handleCloseModal = () => {
    const { week } = currentWeek.currentWeek
    const month = getMonth(week)
    const time = parseInt(localStorage.getItem('ParentDelta'))
    setNewTime(userId, 'screener', time, screenerId, month)
    parentDelta = 0
    setVisible(false)
    props.history.push(HOME_VIEW)
  }

  const handleBack = () => {
    const { week } = currentWeek.currentWeek
    const month = getMonth(week)
    const time = parseInt(localStorage.getItem('ParentDelta'))
    setNewTime(userId, 'screener', time, screenerId, month)
    parentDelta = 0
    props.history.push(HOME_VIEW)
  }

  return (
    <div>
      <MainContainer
        height={'60px'}
        bgcolor={'#F8CF31'}
        className="d-flex align-items-center"
        style={{ position: 'fixed', width: '100%', zIndex: 1 }}
      >
        <Image
          className="mx-3"
          onClick={handleBack}
          height={'25px'}
          width={'25px'}
          src="/images/back.png"
        />
        {/* <Image
          className="mx-2"
          style={{ height: '40px' }}
          src="/images/worksheet.png"
        /> */}
        <h3 className="font mb-0">माता पिता व्यक्तित्व क्विज</h3>
      </MainContainer>
      {showConfetti && <Confetti width={width} height={height} />}

      {visible && (
        <DialogBox
          title={title}
          message={message}
          imgSrc={'/images/check.png'}
          visible={visible}
          color={'green'}
          closeDailogBox={() => handleCloseModal()}
          buttonText={'वापस जाए'}
        />
      )}
      <div
        className="d-flex flex-column justify-content-between"
        // style={{ height: '100vh' }}
      >
        {console.log('questions', questions)}
        {questions.length ? (
          <MainContainer
            className="d-flex flex-column justify-content-between"
            padding={'0px 0px 16px'}
            height={'100vh'}
            style={{ marginTop: '70px', overflow: 'auto' }}
          >
            <MainContainer
              className="mx-3 mt-3"
              bgcolor={'#FDCF32'}
              borderRadius={'5px'}
              height={'100%'}
              style={{ paddingBottom: '90px', overflow: 'auto' }}
            >
              {questions.map(
                (question, index) =>
                  index === activeQuestionIndex &&
                  (console.log('check this ', question, index),
                  (
                    <Question
                      key={question._id}
                      question={question.question}
                      type={question.type}
                      choices={question.option}
                      onSelect={(index) =>
                        setAnswerHandler(
                          index,
                          question._id,
                          question.screenerId
                        )
                      }
                      selected={question.answer}
                      parentScreen={true}
                    />
                  ))
              )}
            </MainContainer>
          </MainContainer>
        ) : null}

        {questions.length ? (
          <div
            className="py-3"
            style={{
              textAlign: 'center',
              bottom: 0,
              position: 'fixed',
              width: '100%',
              backgroundColor: 'white',
            }}
          >
            <AgeButton
              width="150px"
              disabled={
                !questions[activeQuestionIndex].answer &&
                questions[activeQuestionIndex].answer !== 0
              }
              bgcolor={'#12344A'}
              color={'white'}
              padding={'10px'}
              onClick={() =>
                activeQuestionIndex !== lastQuestionIndex
                  ? moveQuestion()
                  : submitAnswers()
              }
            >
              {activeQuestionIndex !== lastQuestionIndex
                ? 'आगे बढ़ें'
                : 'जमा करें'}
            </AgeButton>
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default ParentScreener
